import { Icon } from "@/components/icons/Icon";
import type { CSSProperties } from "react";
import type { DefaultToastOptions } from "react-hot-toast";

const defaultStyle: CSSProperties = {
  maxHeight: "300px",
  height: "fit-content",
  overflowY: "auto",
  alignItems: "start",
  // Identifiers without spaces must wrap without widening the toast beyond its viewport.
  overflowWrap: "anywhere",
};

export const toastOptions: DefaultToastOptions = {
  blank: { duration: 6000, style: defaultStyle },
  success: {
    icon: <Icon name="check" className="text-cds-bright-green-500" />,
    duration: 5000,
    style: defaultStyle,
  },
  error: {
    className: "text-red-500",
    icon: <Icon name="error" className="text-red-500" />,
    duration: 8000,
    style: defaultStyle,
  },
  custom: { duration: 6000, style: defaultStyle },
};
